var _path, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMarketingAdOperations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,40.75h3.12109l.03711,13.25244A.84168.84168,0,0,0,26,54.8418H55.94214c.01977.00049.03808.00586.05786.00586A2.85075,2.85075,0,0,0,58.84766,52V40.707A12.74238,12.74238,0,0,0,58,15.25H22.70581a6.68614,6.68614,0,0,0-.66064-2.23462L25.06055,10,24,8.93945l-2.7832,2.78321a6.74789,6.74789,0,1,0,1.489,5.02734H58a11.2443,11.2443,0,0,1,.84766,22.457V26A.84721.84721,0,0,0,58,25.15234H28.29883A.84721.84721,0,0,0,27.45117,26v3.0957l-1.5166-.00341h-.002a.84105.84105,0,0,0-.8418.84423L25.11694,39.25H22a12.75,12.75,0,0,0,0,25.5H57.29419a6.75,6.75,0,1,0,0-1.5H22a11.25,11.25,0,0,1,0-22.5Zm-6-19.5a5.25009,5.25009,0,1,1,4.13525-8.4458L16,16.93945l-2-2L12.93945,16l2.53028,2.53027a.74971.74971,0,0,0,1.06054,0l4.36939-4.36938A5.19423,5.19423,0,0,1,21.25,16,5.25605,5.25605,0,0,1,16,21.25Zm13.14648,5.59766H57.15234V52a1.15234,1.15234,0,0,1-2.30468,0V50H54.8418V30a.8421.8421,0,0,0-.83985-.8418l-24.85547-.05835ZM53.1582,30.83984V50h-.00586v2a2.82313,2.82313,0,0,0,.25171,1.1582H26.83984l-.06347-22.38037ZM64,58.75A5.25,5.25,0,1,1,58.75,64,5.25605,5.25605,0,0,1,64,58.75Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 35.15234,
    width: 20,
    height: 1.69531
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 41.15234,
    width: 20,
    height: 1.69531
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 47.15234,
    width: 14,
    height: 1.69531
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarketingAdOperations);
export default __webpack_public_path__ + "static/media/icon_marketing_ad_operations.993ce5344e77a5813ffa4909bae4e878.svg";
export { ForwardRef as ReactComponent };